var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DataService from "../../services/DataService";
import Cookies from 'js-cookie';
import _, { isEmpty } from 'lodash';
import { getItemTempatesForPackage, getParsePointer, isSoldOut, captureAffiliate, captureAttribution, calculateDiscounts, getLargeImageURL, getSmallImageURL, getPackageImages, getPackageVideos } from '../../helpers/packages';
import { isSectionSoldOut } from "../../helpers/utils";
import { getItemSelections, updateOrderItemAddOnSelections, updateOrderItemSelectedValues } from "../../helpers/orderItem";
import { inventoryutils } from '../../helpers/inventoryutils';
const ds = DataService.getInstance();
// initial state
const state = {
    affiliate: '',
    attrSource: '',
    currency: '',
    entitlements: [],
    itemAddOns: [],
    itemAddOnsToRemove: [],
    itemOptions: [],
    note: '',
    packageId: '',
    package: {},
    presentation: {},
    section: {},
    addOns: {},
    event: {},
    queryString: { "": "undefined" },
    referralCode: '',
    itemTemplates: [],
    itemOptionSelections: [],
    totalAdditionalPrice: 0,
    totalAddonsCost: 0,
    totalPackageCost: 0,
    totalPackageCostBreakup: [],
    additionalPriceBreakupArray: [],
    itemAddOnsAndLinkedPackageAddOns: [],
    addOnSelections: [],
    orderItem: {},
    useMeals: false,
    useApplication: false,
    mealsArray: [],
    meal: '',
    soldOut: false,
    connectedStripeKeyHash: '',
    discountPct: 0,
    discountFixed: 0,
    images: [],
    videos: [],
    terms: '',
    purchaseRestrictionSegmentComposition: [],
    maxDiscountCodeAllowed: 0,
    linkedPackageMap: {},
};
// getters
const getters = {
    currency: (_state) => _state.currency.toLowerCase(),
    itemAddOns: (_state) => _state.itemAddOns,
    itemAddOnsAndLinkedPackageAddOns: (_state) => _state.itemAddOnsAndLinkedPackageAddOns,
    itemOptions: (_state) => _state.itemOptions,
    packageId: (_state) => _state.packageId,
    addOns: (_state) => _state.addOns,
    mealsArray: (_state) => _state.mealsArray,
    meal: (_state) => _state.meal,
    note: (_state) => _state.note,
    affiliate: (_state) => _state.affiliate,
    attrSource: (_state) => _state.attrSource,
    parseEvent: (_state) => _state.event,
    entitlements: (_state) => _state.entitlements,
    itemTemplates: (_state) => _state.itemTemplates,
    itemOptionSelections: (_state) => _state.itemOptionSelections,
    addOnSelections: (_state) => _state.addOnSelections,
    useMeals: (_state) => _state.useMeals,
    images: (_state) => _state.images,
    videos: (_state) => _state.videos,
    useApplication: (_state) => _state.useApplication,
    connectedStripeKeyHash: (_state) => _state.connectedStripeKeyHash,
    packageDesc: (_state, getters) => getters.parsePackage ? getters.parsePackage.get('desc') : '',
    packageName: (_state, getters) => {
        let name = '';
        if (getters.parsePackage) {
            name = getters.parsePackage.get('name');
        }
        return name;
    },
    sectionName: (_state, getters) => {
        let name = '';
        if (getters.parseSection) {
            name = getters.parseSection.get('name');
        }
        return name;
    },
    categories: (_state, getters) => {
        const categories = [];
        if (getters.parseSection && getters.parsePresentation) {
            categories.push(getters.parsePresentation.get('name'));
            categories.push(getters.parseSection.get('name'));
        }
        return categories;
    },
    largeImageUrl: (_state, getters) => {
        return getLargeImageURL(getters.parsePackage);
    },
    smallImageUrl: (_state, getters) => {
        return getSmallImageURL(getters.parsePackage);
    },
    parsePackage: (_state) => {
        return isEmpty(_state.package) ? null : _state.package;
    },
    parseSection: (_state) => {
        return isEmpty(_state.section) ? null : _state.section;
    },
    parsePresentation: (_state) => {
        return isEmpty(_state.presentation) ? null : _state.presentation;
    },
    soldOut: (_state, getters) => {
        return isSoldOut(getters.parsePackage) || isSectionSoldOut(getters.parseSection);
    },
    packageCost: (_state, getters) => {
        let cost = 0;
        if (getters.parsePackage) {
            cost = getters.parsePackage.get('cost');
        }
        for (const key in state.linkedPackageMap) {
            if (state.linkedPackageMap[key].package && state.linkedPackageMap[key].isPackageAdded) {
                cost += state.linkedPackageMap[key].package.get('cost');
            }
        }
        return cost;
    },
    addOnsCost: (_state, getters) => {
        let addOnCost = 0;
        const addOns = getters.itemAddOns;
        addOns.forEach((addOn) => addOnCost += addOn.cost);
        return addOnCost;
    },
    orderTotal: (_state, getters) => {
        return getters.totalPackageCost + getters.totalAddonsCost + (getters.totalAdditionalPrice || 0);
    },
    totalPackageCost: (_state) => _state.totalPackageCost,
    totalAddonsCost: (_state) => _state.totalAddonsCost,
    totalAdditionalPrice: (_state) => _state.totalAdditionalPrice,
    additionalPriceBreakupArray: (_state) => _state.additionalPriceBreakupArray,
    totalPackageCostBreakup: (_state) => _state.totalPackageCostBreakup,
    discountPct: (_state) => _state.discountPct,
    discountFixed: (_state) => _state.discountFixed,
    discount: (_state, getters) => {
        const total = getters.orderTotal;
        const pct = Math.min(1, Number(getters.discountPct) / 100);
        const fixed = Math.min(getters.orderTotal, getters.discountFixed);
        return total * pct + fixed;
    },
    cartItem: (_state, getters) => {
        const itemOptions = {};
        const itemAddOns = {};
        getters.itemOptions.map((itemTemplate) => {
            itemOptions[itemTemplate.id] = itemTemplate.changes;
        });
        getters.itemAddOns.map((addOn) => {
            itemAddOns[addOn.template_id] = addOn.changes;
        });
        const addToCartItem = {
            affiliate: getters.affiliate,
            attrSource: getters.attrSource,
            currency: _state.currency,
            entitlements: getters.entitlements,
            itemAddOns,
            itemOptions,
            note: getters.note,
            meal: _state.meal,
            queryString: { "": "undefined" },
            referralCode: undefined,
            package_id: getters.parsePackage.id,
            section_id: getters.parseSection.id,
            presentation_id: getters.parsePresentation.id,
            thumbUrl: getters.smallImageUrl,
            linkedPackages: getters.getLinkedPackageMapForCart(getters.parsePackage.id)
        };
        console.log('Add to Cart Item', addToCartItem);
        return addToCartItem;
    },
    getLinkedPackageMapForCart: (_state) => (rootParentPackageId) => {
        /**
         *
         * @param {string} parentPackageId
         * @param {Record<string, any>} packageMap
         * @return {*}  {Partial<AddToCartItem>[]}
         */
        const buildLinkedPackages = (parentPackageId, packageMap) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const linkedPackagesArray = [];
            for (const key in packageMap) {
                const linkedPackage = packageMap[key];
                if ((linkedPackage === null || linkedPackage === void 0 ? void 0 : linkedPackage.parentPackageId) === parentPackageId) {
                    let addToCartItem = {
                        package_id: linkedPackage.packageId,
                        section_id: (_b = (_a = linkedPackage.package) === null || _a === void 0 ? void 0 : _a.get('section')) === null || _b === void 0 ? void 0 : _b.id,
                        presentation_id: (_e = (_d = (_c = linkedPackage.package) === null || _c === void 0 ? void 0 : _c.get('section')) === null || _d === void 0 ? void 0 : _d.get('presentation')) === null || _e === void 0 ? void 0 : _e.id,
                        thumbUrl: getSmallImageURL(linkedPackage.package),
                        currency: linkedPackage.currency,
                        itemAddOns: {},
                        itemOptions: {},
                        entitlements: [],
                        referralCode: undefined,
                        queryString: { '': 'undefined' },
                        linkedPackages: [],
                    };
                    if (linkedPackage.ticketPayload) {
                        // Ensure linked packages are included even with ticketPayload
                        const entitlements = ((_f = linkedPackage.ticketPayload) === null || _f === void 0 ? void 0 : _f.entitlements) || [];
                        addToCartItem = Object.assign(Object.assign({}, addToCartItem), { entitlements: entitlements });
                    }
                    else {
                        const itemAddOns = {};
                        const itemOptions = {};
                        (_g = linkedPackage === null || linkedPackage === void 0 ? void 0 : linkedPackage.itemOptions) === null || _g === void 0 ? void 0 : _g.forEach((itemTemplate) => {
                            itemOptions[itemTemplate.id] = itemTemplate.changes;
                        });
                        (_h = linkedPackage === null || linkedPackage === void 0 ? void 0 : linkedPackage.itemAddOns) === null || _h === void 0 ? void 0 : _h.forEach((addOn) => {
                            itemAddOns[addOn.template_id] = addOn.changes;
                        });
                        addToCartItem = Object.assign(Object.assign({}, addToCartItem), { itemAddOns,
                            itemOptions, note: linkedPackage.note || '', meal: linkedPackage.meal || '', linkedPackages: buildLinkedPackages(linkedPackage.packageId, packageMap) });
                    }
                    linkedPackagesArray.push(addToCartItem);
                }
            }
            return linkedPackagesArray;
        };
        return buildLinkedPackages(rootParentPackageId, _state.linkedPackageMap);
    },
    defaultCommitteeMemberId: (_state, getters) => {
        const member = getters.parseEvent.get('defaultCommitteeMember');
        return member ? member.id : null;
    },
    terms: (_state) => {
        return _state.terms;
    },
    purchaseRestrictionSegmentComposition: (_state) => {
        return _state.purchaseRestrictionSegmentComposition;
    },
    maxDiscountCodeAllowed: (_state) => {
        return _state.maxDiscountCodeAllowed;
    },
    itemAddOnsToRemove: (_state) => {
        return _state.itemAddOnsToRemove;
    },
    orderItem: (_state) => {
        return _state.orderItem;
    },
    linkedPackageMap: (_state) => {
        return _state.linkedPackageMap;
    },
    areAllPackageLinksAdded: (_state) => {
        return Object.keys(_state.linkedPackageMap).every(key => _state.linkedPackageMap[key].isPackageAdded);
    },
    areAllParentPackageLinksAdded: (_state) => (parentPackageId, parentItemOptionId) => {
        return Object.keys(_state.linkedPackageMap).filter(key => _state.linkedPackageMap[key].parentPackageId === parentPackageId &&
            _state.linkedPackageMap[key].parentItemOptionId === parentItemOptionId).every(key => _state.linkedPackageMap[key].isPackageAdded);
    },
};
// actions
const actions = {
    getPackageFromOrderItem: (_a, orderItem_1) => __awaiter(void 0, [_a, orderItem_1], void 0, function* ({ commit, getters }, orderItem) {
        commit('resetOrder');
        const packageId = orderItem.package().id;
        commit('setPackageId', packageId);
        const PackageMembership = Parse.Object.extend("PackageMembership");
        const [eventPackage, itemTemplates, packageAddons, globalAddons, packageImages, packageVideos] = yield Promise.all([
            ds.getPackage(packageId),
            getItemTempatesForPackage(packageId),
            ds.getPackageAddOns(getParsePointer('Package', packageId), PackageMembership),
            ds.getGlobalAddOns(PackageMembership),
            getPackageImages(packageId),
            getPackageVideos(packageId)
        ]);
        const selections = getItemSelections(orderItem);
        commit('setOrderItem', orderItem);
        commit('itemSelections', selections.items);
        commit('addOnSelections', selections.addOns);
        commit('setMeal', selections.meal);
        commit('note', selections.note);
        commit('setPackage', eventPackage);
        commit('setImages', packageImages);
        commit('setVideos', packageVideos);
        commit('setSection', eventPackage.get('section'));
        commit('setPresentation', getters.parseSection.get('presentation'));
        commit('setEvent', getters.parsePresentation.get('season'));
        commit('setCurrency', eventPackage.get('currency'));
        commit('itemTemplates', itemTemplates);
        commit('setMealsArray', getters.parseEvent.get('mealsArray'));
        commit('useMeals', getters.parseEvent.get('useMeals') && !eventPackage.get('section').get('mealsDisabled'));
        commit('useApplication', eventPackage.get('useApplication'));
        commit('addOns', packageAddons.concat(globalAddons));
        commit('connectedStripeKeyHash', getters.parseSection.get('connectedStripeKeyHash'));
        captureAttribution();
        captureAffiliate({ packageId });
        commit('attrSource', Cookies.get('source'));
        commit('affiliate', Cookies.get('affiliate'));
    }),
    getPackage: (_a, packageId_1) => __awaiter(void 0, [_a, packageId_1], void 0, function* ({ commit, dispatch, getters }, packageId) {
        commit('resetOrder');
        commit('setPackageId', packageId);
        const PackageMembership = Parse.Object.extend("PackageMembership");
        const [eventPackage, itemTemplates, packageAddons, globalAddons, packageImages, packageVideos] = yield Promise.all([
            ds.getPackage(packageId),
            getItemTempatesForPackage(packageId),
            ds.getPackageAddOns(getParsePointer('Package', packageId), PackageMembership),
            ds.getGlobalAddOns(PackageMembership),
            getPackageImages(packageId),
            getPackageVideos(packageId)
        ]);
        commit('setPackage', eventPackage);
        dispatch('calculateTotalPackageCost');
        dispatch('calculateTotalPackageCostBreakup');
        commit('setImages', packageImages);
        commit('setVideos', packageVideos);
        commit('setSection', eventPackage.get('section'));
        commit('setPresentation', getters.parseSection.get('presentation'));
        commit('setEvent', getters.parsePresentation.get('season'));
        commit('setCurrency', eventPackage.get('currency'));
        commit('itemTemplates', itemTemplates);
        commit('setMealsArray', getters.parseEvent.get('mealsArray'));
        commit('useMeals', getters.parseEvent.get('useMeals') && !eventPackage.get('section').get('mealsDisabled'));
        commit('useApplication', eventPackage.get('useApplication'));
        commit('addOns', packageAddons.concat(globalAddons));
        commit('connectedStripeKeyHash', getters.parseSection.get('connectedStripeKeyHash'));
        commit('terms', getters.parseSection.get('presentation').get('season').get('terms'));
        commit('purchaseRestrictionSegmentComposition', eventPackage.get('purchaseRestrictionSegmentComposition'));
        commit('maxDiscountCodeAllowed', eventPackage.get('maxDiscountCodeAllowed'));
        captureAttribution();
        captureAffiliate({ packageId });
        commit('attrSource', Cookies.get('source'));
        commit('affiliate', Cookies.get('affiliate'));
    }),
    updateEntitlements: ({ commit, getters, rootGetters }, { selected, entitlementId }) => {
        selected ? commit('addEntitlement', entitlementId) : commit('removeEntitlement', entitlementId);
        const selectedEntitlements = getters.entitlements;
        const userEntitlements = rootGetters['entitlements/paymentEntitlements'];
        const entitlements = userEntitlements.filter(entitlement => selectedEntitlements.includes(entitlement.id));
        const [discountPct, discountFixed] = calculateDiscounts(entitlements);
        commit('discountPct', discountPct);
        commit('discountFixed', discountFixed);
    },
    applyOrderChanges: (_a, orderItemId_1) => __awaiter(void 0, [_a, orderItemId_1], void 0, function* ({ getters }, orderItemId) {
        var _b;
        const addOnSelections = getters.addOnSelections;
        const itemAddOns = getters.itemAddOns;
        const addOnsToRemove = getters.itemAddOnsToRemove;
        let itemAddOnsToUpdate = [];
        let orderItemUpdates = [];
        // check for addOns being added to order
        if (itemAddOns.length) {
            const addOnIdSelections = addOnSelections.map(addOnSelection => addOnSelection.membershipId);
            const newAddOns = itemAddOns.filter((itemAddOn) => !addOnIdSelections.includes(itemAddOn.id));
            orderItemUpdates = newAddOns.map((itemAddOn) => {
                return {
                    id: itemAddOn.id,
                    parent: orderItemId,
                    options: itemAddOn.changes
                };
            });
            itemAddOnsToUpdate = itemAddOns.filter((itemAddOn) => !newAddOns.includes(itemAddOn));
        }
        if (addOnsToRemove.length) {
            for (const addOn of addOnsToRemove) {
                yield Parse.Cloud.run("removeAddOnFromOrderItemByEndUser", { orderItemId, addOnId: (_b = addOn === null || addOn === void 0 ? void 0 : addOn.itemInstance) === null || _b === void 0 ? void 0 : _b.objectId });
            }
        }
        const itemTemplates = getters.itemOptions.flatMap((itemOption) => { var _a; return (_a = itemOption.changes) === null || _a === void 0 ? void 0 : _a.map(changedItem => (Object.assign(Object.assign({}, changedItem), { itemInstance: itemOption.itemInstance }))); });
        const addOns = itemAddOnsToUpdate.flatMap((itemAddOn) => { var _a; return (_a = itemAddOn.changes) === null || _a === void 0 ? void 0 : _a.map(changedItem => (Object.assign(Object.assign({}, changedItem), { itemInstance: itemAddOn.itemInstance }))); });
        const allUpdatedTemplates = itemTemplates.concat(addOns);
        const onlyChangedTemplates = inventoryutils.updateChangedValues(allUpdatedTemplates, _.flatMap(_.concat(getters.itemOptionSelections, getters.addOnSelections)));
        if (onlyChangedTemplates.length > 0 || orderItemUpdates.length > 0 || getters.meal !== getters.orderItem.get('meal_value') || getters.note !== getters.orderItem.get('note')) {
            yield Parse.Cloud.run("editOrderItemFromEndUser", { orderItem: orderItemId, changes: onlyChangedTemplates, orderItemUpdates, meal: getters.meal, note: getters.note });
        }
    }),
    // This action is used to get the package details for a linked package
    getLinkedPackageFromPackageId: (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ commit, getters, state }, { packageId, itemOptionId }) {
        const key = `ItemOptionId_${itemOptionId}_PackageId_${packageId}`;
        if (!getters.linkedPackageMap[key]) {
            console.debug('Creating new linked package map for key:', key);
            state.linkedPackageMap[key] = {};
        }
        commit('setPackageIdForPackageLink', { key, packageId });
        const PackageMembership = Parse.Object.extend("PackageMembership");
        const [eventPackage, itemTemplates, packageAddons, globalAddons, packageImages, packageVideos] = yield Promise.all([
            ds.getPackage(packageId, false),
            getItemTempatesForPackage(packageId),
            ds.getPackageAddOns(getParsePointer('Package', packageId), PackageMembership),
            ds.getGlobalAddOns(PackageMembership),
            getPackageImages(packageId),
            getPackageVideos(packageId)
        ]);
        const section = eventPackage.get('section');
        const mealsArray = getters.parseEvent.get('mealsArray');
        const useMeals = getters.parseEvent.get('useMeals') && !section.get('mealsDisabled');
        const isSoldOutFlag = isSoldOut(eventPackage) || isSectionSoldOut(section);
        const currency = eventPackage.get('currency');
        const addOns = [...packageAddons, ...globalAddons];
        const stripeKeyHash = getters.parseSection.get('connectedStripeKeyHash');
        // Commit all data
        commit('setCurrencyForPackageLink', { key, currency });
        commit('setImagesForPackageLink', { key, images: packageImages });
        commit('setVideosForPackageLink', { key, videos: packageVideos });
        commit('setPackageLinkSoldOut', { key, packageSoldOut: isSoldOutFlag });
        commit('setMealsArrayForPackageLink', { key, mealsArray });
        commit('setUseMealsForPackageLink', { key, useMeals });
        commit('setPackageForPackageLink', { key, eventPackage });
        commit('setItemTemplatesForPackageLink', { key, itemTemplates });
        commit('setAddOnsForPackageLink', { key, addOns });
        commit('connectedStripeKeyHash', stripeKeyHash);
    }),
    // This action updates the order total by calculating the total cost of the package and all linked packages
    updateOrderTotal: ({ dispatch }) => {
        dispatch('calculateAdditionalPriceBreakup');
        dispatch('calculateTotalAdditionalPrice');
        dispatch('calculateTotalAddOnsBreakdown');
        dispatch('calculateTotalAddonsCost');
        dispatch('calculateTotalPackageCost');
        dispatch('calculateTotalPackageCostBreakup');
    },
    calculateTotalPackageCostBreakup: ({ commit, getters, state }) => {
        const totalPackageCostBreakupArray = [];
        const { linkedPackageMap } = state;
        const addPackageCost = (name, cost) => totalPackageCostBreakupArray.push({ name, cost });
        // Add base package if it exists
        if (getters.parsePackage) {
            const baseSuffix = Object.values(linkedPackageMap).some(pkg => pkg.isPackageAdded) ? 'Base Package' : '';
            addPackageCost(paidutils.suffixText(getters.parsePackage.get('name'), baseSuffix), getters.parsePackage.get('cost'));
        }
        // Add linked packages
        for (const key in linkedPackageMap) {
            const pkg = linkedPackageMap[key];
            if (pkg.package && pkg.isPackageAdded) {
                const suffix = pkg.parentItemOptionName || pkg.parentItemTemplateName || '';
                const name = paidutils.suffixText(pkg.package.get('name'), suffix);
                addPackageCost(paidutils.truncateName(name), pkg.package.get('cost'));
            }
        }
        commit('setTotalPackageCostBreakup', totalPackageCostBreakupArray);
    },
    calculateTotalPackageCost: ({ commit, getters, state }) => {
        var _a;
        let totalCost = ((_a = getters.parsePackage) === null || _a === void 0 ? void 0 : _a.get('cost')) || 0;
        // Sum costs from linked packages
        for (const linkedPkg of Object.values(state.linkedPackageMap)) {
            if (linkedPkg.package && linkedPkg.isPackageAdded) {
                totalCost += linkedPkg.package.get('cost') || 0;
            }
        }
        commit('setTotalPackageCost', totalCost);
    },
    calculateTotalAddonsCost: ({ commit, getters, state }) => {
        const sumAddonCosts = (addons = []) => addons.reduce((total, addOn) => total + (addOn.cost || 0), 0);
        let totalAddOnsCost = sumAddonCosts(getters.itemAddOns);
        // Sum addon costs from linked packages
        for (const pkg of Object.values(state.linkedPackageMap)) {
            if (pkg.isPackageAdded) {
                totalAddOnsCost += sumAddonCosts(pkg.itemAddOns);
            }
        }
        commit('setTotalAddonsCost', totalAddOnsCost);
    },
    calculateTotalAddOnsBreakdown: ({ commit, state }) => {
        const addOnsTotalBreakdown = [];
        const { itemAddOns, linkedPackageMap } = state;
        const addAddon = (name, cost) => addOnsTotalBreakdown.push({ name, cost });
        const considerBaseAddonLabel = Object.values(linkedPackageMap).some(pkg => pkg.itemAddOns && pkg.isPackageAdded);
        // Add base item add-ons
        for (const addOn of itemAddOns) {
            const baseSuffix = considerBaseAddonLabel ? 'Base Package' : '';
            addAddon(paidutils.suffixText(addOn.name, baseSuffix), addOn.cost);
        }
        // Add linked package add-ons
        for (const key in linkedPackageMap) {
            const pkg = linkedPackageMap[key];
            if (pkg.itemAddOns && pkg.isPackageAdded) {
                for (const addOn of pkg.itemAddOns) {
                    const suffix = pkg.parentItemOptionName || pkg.parentItemTemplateName || '';
                    const name = paidutils.suffixText(addOn.name, suffix);
                    addAddon(paidutils.truncateName(name), addOn.cost);
                }
            }
        }
        commit('setTotalAddOnsBreakdown', addOnsTotalBreakdown);
    },
    calculateTotalAdditionalPrice: ({ commit, getters, state }) => {
        const sumDeltaPrices = (options) => options === null || options === void 0 ? void 0 : options.reduce((total, option) => total + (option.deltaPrice || 0), 0);
        let totalAdditionalPrice = 0;
        // Sum delta prices from base item options and add-ons
        totalAdditionalPrice += sumDeltaPrices(getters.itemOptions);
        totalAdditionalPrice += sumDeltaPrices(getters.itemAddOns);
        // Sum delta prices from linked package options and add-ons
        for (const pkg of Object.values(state.linkedPackageMap)) {
            if (pkg.isPackageAdded) {
                totalAdditionalPrice += sumDeltaPrices(pkg.itemOptions || []);
                totalAdditionalPrice += sumDeltaPrices(pkg.itemAddOns || []);
            }
        }
        commit('setTotalAdditionalPrice', totalAdditionalPrice);
    },
    calculateAdditionalPriceBreakup: ({ commit, getters, state }) => {
        let additionalPriceBreakupArray = [];
        const { linkedPackageMap } = state;
        const filterOptionsWithDelta = (options) => (options === null || options === void 0 ? void 0 : options.filter(option => option.deltaPrice !== 0)) || [];
        const addPriceBreakup = (name, deltaPrice) => additionalPriceBreakupArray.push({ name, deltaPrice });
        const basePackageOptions = _.concat(getters.itemOptions, getters.itemAddOns);
        const hasDeltaInPackages = Object.values(linkedPackageMap).some(pkg => (pkg.itemOptions && pkg.isPackageAdded && pkg.itemOptions.some(opt => opt.deltaPrice !== 0)) ||
            (pkg.itemAddOns && pkg.isPackageAdded && pkg.itemAddOns.some(addon => addon.deltaPrice !== 0)));
        // Add base package options with delta prices
        for (const option of filterOptionsWithDelta(basePackageOptions)) {
            const suffix = hasDeltaInPackages ? 'Base Package' : '';
            addPriceBreakup(paidutils.suffixText(option.name, suffix), option.deltaPrice);
        }
        // Add linked package options and add-ons with delta prices
        for (const pkg of Object.values(linkedPackageMap)) {
            if (pkg.isPackageAdded) {
                const suffix = pkg.parentItemOptionName || pkg.parentItemTemplateName || '';
                for (const option of filterOptionsWithDelta(pkg.itemOptions || [])) {
                    addPriceBreakup(paidutils.suffixText(option.name, suffix), option.deltaPrice);
                }
                for (const addon of filterOptionsWithDelta(pkg.itemAddOns || [])) {
                    addPriceBreakup(paidutils.suffixText(addon.name, suffix), addon.deltaPrice);
                }
            }
        }
        additionalPriceBreakupArray = additionalPriceBreakupArray.map((option) => {
            var _a;
            return ({
                name: paidutils.truncateName(option.name),
                deltaPrice: (_a = option.deltaPrice) !== null && _a !== void 0 ? _a : 0,
            });
        });
        commit('setAdditionalPriceBreakupArray', additionalPriceBreakupArray);
    },
    resetLinkedPackageMap: ({ commit, dispatch }) => {
        commit('resetLinkedPackageMap');
        dispatch('updateOrderTotal');
    }
};
// mutations
const mutations = {
    setCurrencyForPackageLink(state, { key, currency }) {
        const defaultCurrency = Parse.Config.current().get('stripeCurrency');
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { currency: currency || defaultCurrency });
    },
    setMealForPackageLink(state, { key, meal }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { meal });
    },
    setNoteForPackageLink(state, { key, note }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { note });
    },
    setTotalPackageCostBreakup(state, totalPackageCostBreakup) {
        state.totalPackageCostBreakup = totalPackageCostBreakup;
    },
    setTotalPackageCost(state, totalPackageCost) {
        state.totalPackageCost = totalPackageCost;
    },
    setTotalAddonsCost(state, totalAddonsCost) {
        state.totalAddonsCost = totalAddonsCost;
    },
    setTotalAddOnsBreakdown(state, itemAddOnsAndLinkedPackageAddOns) {
        state.itemAddOnsAndLinkedPackageAddOns = itemAddOnsAndLinkedPackageAddOns;
    },
    setTotalAdditionalPrice(state, totalAdditionalPrice) {
        state.totalAdditionalPrice = totalAdditionalPrice;
    },
    setAdditionalPriceBreakupArray(state, additionalPriceBreakupArray) {
        state.additionalPriceBreakupArray = additionalPriceBreakupArray;
    },
    // added this flag to false for soldOut linked packages
    markLinkedPackageSoldOut(state, { key }) {
        if (!state.linkedPackageMap[key]) {
            state.linkedPackageMap[key] = {};
        }
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { isPackageAdded: false });
    },
    //  Initialize the linkedPackageMap, which helps to identify the parent package for linked packages
    initSingleLinkedPackage(state, { key, parentPackageId, parentItemOptionId, parentItemTemplateId, parentItemOptionName, parentItemTemplateName }) {
        if (!state.linkedPackageMap[key]) {
            state.linkedPackageMap[key] = {};
        }
        state.linkedPackageMap[key].parentPackageId = parentPackageId;
        state.linkedPackageMap[key].parentItemOptionId = parentItemOptionId;
        state.linkedPackageMap[key].parentItemTemplateId = parentItemTemplateId;
        state.linkedPackageMap[key].parentItemTemplateName = parentItemTemplateName;
        state.linkedPackageMap[key].parentItemOptionName = parentItemOptionName;
    },
    // Reset the linkedPackageMap to an empty object
    resetLinkedPackageMap(state) {
        state.linkedPackageMap = {};
    },
    // Add a flag to the linkedPackageMap to indicate that the package has been added to the order
    addLinkPackageToOrder(state, { key }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { isPackageAdded: true });
    },
    setImagesForPackageLink(state, { key, images }) {
        state.linkedPackageMap[key].packageImages = [];
        for (const image of images) {
            state.linkedPackageMap[key].packageImages.push({
                id: image.id,
                originalUrl: image.get('image') ? image.get('image').url() : null,
                largeUrl: image.get('thumbnail_large') ? image.get('thumbnail_large').url() : null
            });
        }
    },
    setVideosForPackageLink(state, { key, videos }) {
        state.linkedPackageMap[key].packageVideos = [];
        for (const video of videos) {
            state.linkedPackageMap[key].packageVideos.push({
                id: video.id,
                playbackId: video.get('playbackId')
            });
        }
    },
    setPackageLinkSoldOut(state, { key, packageSoldOut }) {
        state.linkedPackageMap[key].packageSoldOut = packageSoldOut;
    },
    setMealsArrayForPackageLink(state, { key, mealsArray }) {
        state.linkedPackageMap[key].mealsArray = mealsArray;
    },
    setUseMealsForPackageLink(state, { key, useMeals }) {
        state.linkedPackageMap[key].useMeals = useMeals;
    },
    setPackageForPackageLink(state, { key, eventPackage }) {
        state.linkedPackageMap[key].package = eventPackage;
    },
    setItemTemplatesForPackageLink(state, { key, itemTemplates }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { itemTemplates });
    },
    setAddOnsForPackageLink(state, { key, addOns }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { addOns });
    },
    addItemOptionForPackageLink(state, { key, itemOption }) {
        var _a;
        const itemOptions = ((_a = state.linkedPackageMap[key]) === null || _a === void 0 ? void 0 : _a.itemOptions) || [];
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { itemOptions: updateOrderItemSelectedValues(itemOptions, itemOption) });
    },
    setPackageIdForPackageLink(state, { key, packageId }) {
        state.linkedPackageMap[key].packageId = packageId;
    },
    addItemAddonForPackageLink(state, { key, itemAddOn }) {
        var _a;
        const itemAddOns = ((_a = state.linkedPackageMap[key]) === null || _a === void 0 ? void 0 : _a.itemAddOns) || [];
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { itemAddOns: updateOrderItemAddOnSelections(itemAddOns, itemAddOn) });
    },
    removeAddonForPackageLink(state, { key, membershipId }) {
        var _a, _b;
        state.linkedPackageMap[key].itemAddOns = ((_b = (_a = state.linkedPackageMap[key]) === null || _a === void 0 ? void 0 : _a.itemAddOns) === null || _b === void 0 ? void 0 : _b.filter((addOn) => addOn.id !== membershipId)) || [];
    },
    removeRelatedPackageLinks(state, { itemTemplateId }) {
        state.linkedPackageMap = Object.fromEntries(Object.entries(state.linkedPackageMap).filter(([, value]) => value.parentItemTemplateId !== itemTemplateId));
    },
    setTicketPayloadForLinkedPackage(state, { key, ticketPayload }) {
        state.linkedPackageMap[key] = Object.assign(Object.assign({}, state.linkedPackageMap[key]), { ticketPayload });
    },
    addOns(state, addOns) {
        state.addOns = _.orderBy(addOns, [(addon) => {
                return _.isNumber(addon.get("sortOrder")) ? addon.get("sortOrder") : addon.createdAt;
            }
        ], [((addon) => { return _.isNumber(addon.get("sortOrder")) ? "asc" : "desc"; })]);
    },
    setPackageId(state, packageId) {
        state.packageId = packageId;
    },
    setImages(state, images) {
        state.images = [];
        for (const image of images) {
            state.images.push({
                id: image.id,
                originalUrl: image.get('image') ? image.get('image').url() : null,
                largeUrl: image.get('thumbnail_large') ? image.get('thumbnail_large').url() : null
            });
        }
    },
    setVideos(state, videos) {
        state.videos = [];
        for (const video of videos) {
            state.videos.push({
                id: video.id,
                playbackId: video.get('playbackId')
            });
        }
    },
    setPackage(state, eventPackage) {
        state.package = eventPackage;
    },
    setSection(state, section) {
        state.section = section;
    },
    setPresentation(state, presentation) {
        state.presentation = presentation;
    },
    setEvent(state, event) {
        state.event = event;
    },
    setCurrency(state, currency) {
        const defaultCurrency = Parse.Config.current().get('stripeCurrency');
        state.currency = currency || defaultCurrency;
    },
    setMealsArray(state, mealsArray) {
        state.mealsArray = mealsArray || [];
    },
    setMeal(state, meal) {
        state.meal = meal;
    },
    useMeals(state, useMeals) {
        state.useMeals = useMeals;
    },
    useApplication(state, useApplication) {
        state.useApplication = useApplication;
    },
    itemTemplates(state, itemTemplates) {
        state.itemTemplates = _.orderBy(itemTemplates, [(itemTemplate) => {
                return _.isNumber(itemTemplate.sortOrder) ? itemTemplate.sortOrder : itemTemplate.createdAt;
            }
        ], [((itemTemplate) => { return _.isNumber(itemTemplate.sortOrder) ? "asc" : "desc"; })]);
    },
    addItemOption(state, itemOption) {
        state.itemOptions = updateOrderItemSelectedValues(state.itemOptions, itemOption);
    },
    itemOptions(state, itemOptions) {
        state.itemOptions = itemOptions;
    },
    removeItemAddOn(state, membershipId) {
        const addonToRemove = state.addOnSelections.find((addOn) => addOn.membershipId === membershipId);
        state.itemAddOns = state.itemAddOns.filter((addOn) => addOn.id !== membershipId);
        if (addonToRemove && !state.itemAddOnsToRemove.some((addOn) => addOn.id === addonToRemove.id)) {
            state.itemAddOnsToRemove.push(addonToRemove);
        }
    },
    updateItemAddOn(state, itemAddOn) {
        state.itemAddOns = updateOrderItemAddOnSelections(state.itemAddOns, itemAddOn);
        state.itemAddOnsToRemove = state.itemAddOnsToRemove.filter((addOn) => addOn.membershipId !== itemAddOn.id);
    },
    note(state, note) {
        state.note = note;
    },
    affiliate(state, affiliate) {
        state.affiliate = affiliate;
    },
    attrSource(state, attrSource) {
        state.attrSource = attrSource;
    },
    connectedStripeKeyHash(state, connectedStripeKeyHash) {
        state.connectedStripeKeyHash = connectedStripeKeyHash;
    },
    addEntitlement(state, entitlementId) {
        if (!state.entitlements.includes(entitlementId)) {
            state.entitlements = state.entitlements.concat(entitlementId);
        }
    },
    removeEntitlement(state, entitlementId) {
        state.entitlements = state.entitlements.filter(entitlement => entitlement !== entitlementId);
    },
    discountPct(state, discountPct) {
        state.discountPct = discountPct;
    },
    discountFixed(state, discountFixed) {
        state.discountFixed = discountFixed;
    },
    itemSelections(state, itemOptionSelections) {
        state.itemOptionSelections = itemOptionSelections;
    },
    addOnSelections(state, addOnSelections) {
        state.addOnSelections = addOnSelections;
    },
    setOrderItem(state, orderItem) {
        state.orderItem = orderItem;
    },
    terms(state, terms) {
        state.terms = terms;
    },
    purchaseRestrictionSegmentComposition(state, purchaseRestrictionSegmentComposition) {
        state.purchaseRestrictionSegmentComposition = purchaseRestrictionSegmentComposition;
    },
    maxDiscountCodeAllowed(state, maxDiscountCodeAllowed) {
        state.maxDiscountCodeAllowed = maxDiscountCodeAllowed;
    },
    resetOrder(state) {
        state.affiliate = '';
        state.attrSource = '';
        state.currency = '';
        state.entitlements = [];
        state.itemAddOns = [];
        state.itemOptions = [];
        state.note = '';
        state.packageId = '';
        state.package = {};
        state.presentation = {};
        state.section = {};
        state.addOns = [];
        state.itemAddOnsToRemove = [];
        state.event = {};
        state.queryString = { "": "undefined" };
        state.referralCode = '';
        state.itemTemplates = [];
        state.useMeals = false;
        state.mealsArray = [];
        state.meal = '';
        state.soldOut = false;
        state.discountPct = 0;
        state.discountFixed = 0;
        state.itemOptionSelections = [];
        state.totalAdditionalPrice = 0;
        state.addOnSelections = [];
        state.terms = '';
        state.purchaseRestrictionSegmentComposition = [];
        state.maxDiscountCodeAllowed = 0;
        state.orderItem = {};
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
